module.exports = __webpack_public_path__ + "img/FK.54c692dd.svg";